<script>
    export let title = "";
    export let subtitle = "";
    export let tabs = [];

    let selectedKey = tabs.length ? tabs[0].key : null;
</script>
  
<section class="max-w-3xl space-y-4">
    <div>
      <h2 class="text-lg font-bold text-[var(--app-title-color)]">{title}</h2>
      <p class="text-sm text-[var(--app-text-color-darker)]">{subtitle}</p>
    </div>
    {#if tabs.length}
        <div>
            <div class="flex space-x-4 border-b border-[var(--app-background-level-3)]">
                {#each tabs as tab}
                <!--<button
                    class="py-2 px-4 text-sm font-medium focus:outline-none"
                    class:selected={selectedKey === tab.key}
                    on:click={() => selectedKey = tab.key}>
                    {tab.label}
                </button>-->

                <button
					class="px-4 py-2 -mb-px font-semibold text-sm capitalize border-b-2 transition-colors duration-200"
					class:text-[var(--app-primary-color)]={selectedKey === tab.key}
					class:border-transparent={selectedKey !== tab.key}
					class:text-gray-500={selectedKey !== tab.key}

                    style="
                        background-color: {selectedKey === tab.key ? 'var(--app-background-level-1)' : 'transparent'};
                        border-color: {selectedKey === tab.key ? 'var(--app-background-level-3)' : 'transparent'};
                        border-bottom-color: {selectedKey === tab.key ? 'var(--app-background-level-1)' : 'transparent'};
                        margin-bottom: -2px;
                        z-index: 10;
                        position: relative;
                    "

					on:click={() => (selectedKey = tab.key)}
				>{tab.label}
                </button>

                {/each}
            </div>

            <div class="border rounded p-6" style="background-color: var(--app-background-level-1); border-color: var(--app-background-level-3);">
                <div style:display={selectedKey === 'slot1' ? 'block' : 'none'}>
                    <slot name="slot1" />
                </div>
                <div style:display={selectedKey === 'slot2' ? 'block' : 'none'}>
                    <slot name="slot2" />
                </div>
                <div style:display={selectedKey === 'slot3' ? 'block' : 'none'}>
                    <slot name="slot3" />
                </div>
                <div style:display={selectedKey === 'slot4' ? 'block' : 'none'}>
                    <slot name="slot4" />
                </div>
                <div style:display={selectedKey === 'slot5' ? 'block' : 'none'}>
                    <slot name="slot5" />
                </div>
                <div style:display={selectedKey === 'slot6' ? 'block' : 'none'}>
                    <slot name="slot6" />
                </div>
                <div style:display={selectedKey === 'slot7' ? 'block' : 'none'}>
                    <slot name="slot7" />
                </div>
                <div style:display={selectedKey === 'slot8' ? 'block' : 'none'}>
                    <slot name="slot8" />
                </div>
            </div>
        </div>
    {/if}
</section>

<!--<style>
    button.selected {
        border-bottom: 2px solid var(--app-accent-color);
        color: var(--app-accent-color);
    }
</style>-->